import { Block } from "../../../styles/basicStyles";
import styled from "styled-components";
import { breakpoints } from "../../../styles/breakpoints";

export const CardWrapper = styled(Block)`
  flex-flow: row wrap;
  width: calc(100% + 2.25rem);

  @media ${breakpoints.xs} {
    width: 100%;
  }
`;